import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface SessionLostState {
  isSessionLost: boolean;
}

const initialState: SessionLostState = {
  isSessionLost: false,
};

export const sessionLostSlice = createSlice({
  name: 'sessionLost',
  initialState,
  reducers: {
    setIsSessionLost: (state, action: PayloadAction<boolean>) => {
      state.isSessionLost = action.payload;
    },
  },
});

export const { setIsSessionLost } = sessionLostSlice.actions;
